import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styles from './card.module.css';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';

export default function MediaCard(props) {

  const {setCategoryFn} = useGlobalState();

  return (
    <Card sx={{ maxWidth: 290 }}>
      <CardMedia
        sx={{ height: 275 }}
        image={props.imgSrc}
        title="green iguana"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {props.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <h2>{props.subject}</h2>
          <h3>Monthly fees : ₹ {props.monthlyFees}</h3>
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small">Share</Button>
        <Button onClick={() => setCategoryFn('expert_schedule')} className={styles.see_sessions_button} size="small">See session timings</Button>
      </CardActions>
    </Card>
  );
}